/** @format */

//!enums for surveyStatus
export enum EnumSurveyAnswerStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  REJECTED = "rejected",
  SAVED_AS_DRAFT = "saved_as_draft",
  SAVE_AS_DRAFT = "saved as draft",
  NONE = "none",
}
//!enums for questionTypes
export enum EnumQuestionType {
  RADIO = "radio",
  DROP_DOWN = "drop_down",
  CHECKBOX = "checkbox",
  RATING = "rating",
  NUMBER = "number",
  TEXT = "text",
  FILE = "file_upload",
  TEXTAREA = "text_area",
  MATRIX = "matrix",
  DATE = "date",
  PERCENTAGE = "percentage",
  CUSTOM_FORM = "custom_form",
}
//!enums for textTypes
export enum EnumTypeTexts {
  NOTE = "note",
  ATTACHMENTS = "attachments",
  NO = "no",
  YES = "yes",
  NA = "NA",
}
//manuplating the SuveyStatus in JSX
export const manuplateSurveyStatus: any = {
  [EnumSurveyAnswerStatus.PENDING]: EnumSurveyAnswerStatus.PENDING,
  [EnumSurveyAnswerStatus.COMPLETED]: EnumSurveyAnswerStatus.COMPLETED,
  [EnumSurveyAnswerStatus.REJECTED]: EnumSurveyAnswerStatus.REJECTED,
  [EnumSurveyAnswerStatus.SAVED_AS_DRAFT]: EnumSurveyAnswerStatus.SAVE_AS_DRAFT,
  [EnumSurveyAnswerStatus.NONE]: "-",
};
//impact Risk Response
export enum ImpactRiskResponse {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  EXTREME = "extreme",
}

export enum UniqueOptionType {
  OTHERS = "Others",
}
//enum for short and large Matrix text field
export enum MatrixTextFieldType {
  SHORT = "short",
  LARGE = "large",
}
export enum AssessmentType {
  ACTIVE = "active",
  PAST = "past",
}
//enums\
export enum MatrixTypesEnum {
  CHECKBOX = "checkbox",
  TEXT = "text",
  NUMBER = "number",
  CONSTANT_SUM = "Constant Sum",
}
//enum date types
export enum DateTypeEnum {
  DATE = "date",
  RANGE = "range",
}
//enum date types
export enum DateFormatTypeEnum {
  YEAR = "YYYY",
  MONTH = "MM/DD/YYYY",
  DATE = "DD/MM/YYYY",
}
//enum date rangeType
export enum RangeTypeEnum {
  FROM = "from",
  TO = "to",
}
export enum TemplateNameEnum {
  MULTIPLES = "multiples",
  MULTIPLES_ST = "multiplesST",
  ILPA = "ilpa",
}
export enum AssessmentName {
  ASSESSMENT = "Assessment",
  SURVEY = "Survey",
}

export enum formulaTypes {
  SUM = "sum",
  MULTIPLY = "multiply",
  AVERAGE = "average",
  DIVISION = "division",
  PERCENTAGE = "percentage",
  CONSTANT_SUM = "constant_sum",
  SUBTRACTION = "subtraction",
}

export const formulaTypesMapping: {
  [key in formulaTypes]: string;
} = {
  [formulaTypes.SUM]: "Sum",
  [formulaTypes.MULTIPLY]: "Multiply",
  [formulaTypes.AVERAGE]: "Average",
  [formulaTypes.DIVISION]: "Division",
  [formulaTypes.PERCENTAGE]: "Percentage",
  [formulaTypes.CONSTANT_SUM]: "Constant Sum",
  [formulaTypes.SUBTRACTION]: "Subtraction",
};
